module.exports = __webpack_public_path__ + "img/galeria-ornamentales-4.94f81da3.jpg";